export default __webpack_public_path__ + "static/media/No Wishlist.205c0922.webp";